var borders_default = {
  "borderT": "mGGdH",
  "borderB": "EHILW",
  "borderL": "_8A3h9",
  "borderR": "kNq2H"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
